<script lang="ts">
  import cn from 'classnames'

  import GameStatusButton from '#components/GameStatusButton_svelte.svelte'
  import type { CommentAttachment } from '#components/comments/CommentTypes'

  import css from '#css/comments.pcss.json'

  export let attachment: CommentAttachment
  export let onlyAttachment: boolean = false
</script>

<a
  href={attachment.gameInfo.url ?? attachment.url} class={cn({
    [css['comment__attachment__game']]: true,
    [css['comment__attachment--only']]: onlyAttachment
  })}
>
  <picture>
    {#if !attachment.gameInfo.poster.includes('/placeholder/')}
      <img alt="" src={attachment.gameInfo.poster} loading="lazy"/>
    {/if}
  </picture>
  <span class={css['comment__attachment__game__title']}>{attachment.gameInfo.name}</span>
  <span class={css['comment__attachment__game__date']}>{attachment.gameInfo.releaseDate}</span>
  <GameStatusButton gameId={attachment.gameId} status={attachment.gameInfo.status}/>
  <slot name="delete"></slot>
</a>
